import AgreementRunProgressNotification from "./AgreementRunProgressNotification";
import UploaderRoot from "../data/uploads/uploader/Root";
import { Box, makeStyles } from "@material-ui/core";
import BulkRoot from "../data/uploads/uploader/BulkRoot";

const useStyles = makeStyles(({ palette }) => ({
	snackBarContainer: {
		position: "fixed",
		bottom: "57px",
		right: "70px",
		zIndex: 102,
	},
}));

const LayoutSnackbar = () => {
	const { snackBarContainer } = useStyles();
	return (
		<Box className={snackBarContainer}>
			<AgreementRunProgressNotification />
			<UploaderRoot />
			<BulkRoot />
		</Box>
	);
};

export default LayoutSnackbar;
